/**************************************************
 * Nombre:       Tarjeta_Inspiracion
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import fondo from '../../Recursos/fondo_tela_tarjeta.png'
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import iconos from "../../Recursos/iconos_footer.png";

const Tarjeta_Tela = () => {
    const {sCell, masSM} = useResponsive()

    return (
        <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="flex-start"
        >
            <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="flex-start"
                sx={{
                    maxWidth: '1400px',
                    mx: 3,
                    backgroundImage: `url(${fondo});`,
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition:sCell ? 'right' :  'center',
                    backgroundSize: 'cover',
                    borderTopLeftRadius: 60,
                    borderBottomRightRadius: 60,
                    p: 8
                }}
            >


                <Grid item container lg={12} sm={12} xs={12}
                      sx={{justifyContent: 'flex-start', marginTop: masSM ? 4 : 4}}>
                    <Typography sx={{fontSize: sCell ? 12 : 18, color: '#fff', fontWeight: 400,}}>
                        Fabric Type
                    </Typography>
                </Grid>

                <Grid item container lg={12} sm={12} xs={12} sx={{justifyContent: 'flex-start', marginTop: 0}}>
                    <Typography sx={{
                        fontSize: sCell ? 24 : 42,
                        color: '#fff',
                        fontWeight: 700,
                        lineHeight: 1.1

                    }}>RECYCLED TEXTILE</Typography>
                </Grid>


                <Grid item container lg={12} sm={12} xs={12}
                      sx={{justifyContent: 'flex-start', marginTop:0}}>
                    <Typography sx={{fontSize: sCell ? 12 : 18, color: '#fff', fontWeight: 400,}}>
                        from pet bottles
                    </Typography>
                </Grid>

                <Grid item container lg={4} sm={12} xs={12}
                      sx={{justifyContent: 'flex-start', marginTop: 6}}>
                    <Typography sx={{fontSize: sCell ? 12 : 14, color: '#fff', fontWeight: 400, textAlign: 'left'}}>
                        BY SARASTY explores the use of quality tailoring and rich Hi-Tech fabrics made in Colombia:
                        <br/>
                        <br/>
                        • Recycled Textile from Pet bottles
                        <br/>
                        • 50% UV Protection Shield
                        <br/>
                        • Waterproof Shield
                        <br/>
                        • Digital Stamping with 0 water
                        <br/>
                        <br/>
                        An Eco-Friendly brand
                    </Typography>
                </Grid>

                <Grid item container lg={12} sm={12} xs={12}
                      sx={{justifyContent: sCell ? 'center' : 'flex-start', ml: -4, marginBottom: 0}}>
                    <img src={iconos} width={300} height={'auto'}/>
                </Grid>

            </Grid>


        </Grid>
    )

}
export default Tarjeta_Tela